import React from 'react';

const ITEMS = [
  'Reads SAM.gov',
  'NAICS-aware matching',
  'Set-aside intelligence',
  'Evidence-grounded drafting',
  'WCAG 2.2 AA',
];

/** Thin trust band between the hero and the narrative. */
export function CapabilityStrip() {
  return (
    <section className="border-y border-bw-border bg-bw-surface">
      <div className="max-w-[1180px] mx-auto px-5 sm:px-8 py-[22px] flex flex-wrap items-center gap-x-9 gap-y-3.5">
        <span className="font-mono text-[11px] font-semibold tracking-[0.14em] text-bw-muted">
          BUILT FOR FEDERAL ·
        </span>
        {ITEMS.map((item) => (
          <span key={item} className="text-sm font-semibold text-fit-weak">
            {item}
          </span>
        ))}
      </div>
    </section>
  );
}
